/**
 * Do dai (phut) cua mot item khi gui booking/update.
 *
 * Do dai thuc te cua mot lich khong nhat thiet bang tong duration cua dich vu: nhan vien
 * co the keo dai/rut ngan lich bang nut +/- time hoac keo tha tren lich. Vi vay khi sua mot
 * lich da co ma danh sach dich vu khong doi (vi du chi tich Request Staff), phai giu nguyen
 * do dai goc; tinh lai tu duration dich vu se lam lich co lai.
 */
export const resolveBookingDuration = (params: {
  /** Dang sua lich da co, khong phai dat lich moi. */
  isUpdate: boolean;
  /** Service id cua lich luc mo modal. */
  serviceIdsBefore: string[];
  /** Service id dang chon. */
  serviceIdsNow: string[];
  /** So nhom staff trong payload: >1 nghia la dich vu bi tach cho nhieu tho. */
  staffGroupCount: number;
  /** Tong duration cua dich vu trong nhom staff nay. */
  servicesDuration: number;
  /** Do dai goc cua lich (end - start), 0 khi dat lich moi. */
  originalDuration: number;
}): number => {
  const { isUpdate, serviceIdsBefore, serviceIdsNow, staffGroupCount, servicesDuration, originalDuration } = params;

  const keepOriginal = isUpdate
    && staffGroupCount === 1
    && isSameServiceSelection(serviceIdsBefore, serviceIdsNow);

  if (keepOriginal && originalDuration > 0) {
    return originalDuration;
  }

  return servicesDuration || originalDuration;
};

/** So sanh hai danh sach service id, khong phu thuoc thu tu. */
export const isSameServiceSelection = (a: string[], b: string[]): boolean => {
  if (a.length !== b.length) return false;
  const sortedA = [...a].map(String).sort();
  const sortedB = [...b].map(String).sort();
  return sortedA.every((id, index) => id === sortedB[index]);
};
